import { useNavigate } from 'react-router-dom';
import { GeneratedImage } from '../services/api/imageGenerationService';

export const useNavigateToVideo = () => {
  const navigate = useNavigate();

  const navigateToVideo = (image: GeneratedImage, onBeforeNavigate?: () => void) => {
    if (!image.s3_key) return;

    const performNavigation = (aspectRatio: '16:9' | '9:16') => {
      onBeforeNavigate?.();
      navigate('/ads/video', {
        state: {
          refImageS3Key: image.s3_key,
          refImageUrl: image.url,
          preferredStyle: 'バナー動画',
          imageAspectRatio: aspectRatio,
        },
      });
    };

    const img = new window.Image();
    img.onload = () => {
      const ratio = img.naturalWidth / img.naturalHeight;
      performNavigation(ratio >= 1 ? '16:9' : '9:16');
    };
    img.onerror = () => performNavigation('16:9');
    img.src = image.url;
  };

  return { navigateToVideo };
};
